import * as Constants from './components/AssetExplorerComponent/constants';

export function findTranslation(jsonData, key = '', value = '') {
  function AssetExplorerTranslations(jsonData) {
    this.AssetTypeTranslations = [];
    this.AssetSubTypeTranslations = [];
    this.CampaignTranslations = [];
    this.OurCausesTranslations = [];
    this.KeywordTranslations = [];
    this.LanguageTranslations = [];
    this.RegionTranslations = [];
    this.FacetHeadings = [];

    this.JsonObject = jsonData;
    this._setTranslationsArrays();
  }

  AssetExplorerTranslations.FacetType = Object.freeze({
    //todo we should get this from sitecore
    AssetType: Constants.AssetTypeTemplateId,
    AssetSubType: Constants.AssetSubTypeTemplateId,
    Campaign: Constants.CampaignTemplateId,
    OurCauses: Constants.OurCausesTemplateId,
    Keywords: Constants.KeywordsTemplateId,
    Region: Constants.RegionTemplateId,
    Language: Constants.LanguageTemplateId,
    FacetHeading: Constants.FacetHeadingId,
  });

  AssetExplorerTranslations.prototype._findValue = function (translationArray, value) {
    try {
      var result = translationArray.filter((obj) => {
        return obj?.fields?.value?.value === value;
      });

      if (result && result[0]) {
        return result[0]?.fields?.displayText?.value;
      }

      return null;
    } catch (exception) {
      console.log(exception);
      return value;
    }
  };

  AssetExplorerTranslations.prototype.Find = function (facetType, value) {
    let t = '';
    switch (facetType) {
      case Constants.AssetTypeId:
        t = this._findValue(this.AssetTypeTranslations, value);
        return t ? t : '';
      case Constants.AssetSubTypeId:
        t = this._findValue(this.AssetSubTypeTranslations, value);
        return t ? t : '';
      case Constants.CampaignTypeId:
        t = this._findValue(this.CampaignTranslations, value);
        return t ? t : '';
      case Constants.OurCausesTypeId:
        t = this._findValue(this.OurCausesTranslations, value);
        return t ? t : '';
      case Constants.KeywordTypeId:
        t = this._findValue(this.KeywordTranslations, value);
        return t ? t : '';
      case Constants.RegionTypeId:
        t = this._findValue(this.RegionTranslations, value);
        return t ? t : '';
      case Constants.LanguagesTypeId:
        t = this._findValue(this.LanguageTranslations, value);
        return t ? t : value;
      case Constants.FacetHeadingId:
        t = this._findValue(this.FacetHeadings, value);
        return t ? t : value;
      default:
        console.log('type not found');
    }
  };

  AssetExplorerTranslations.prototype._setTranslationsArray = function (translationsNode, sitecoreId) {
    try {
      var result = translationsNode.filter((obj) => {
        return obj.id === sitecoreId;
      });

      if (result[0]?.fields?.children?.length > 0) {
        return result[0]?.fields?.children;
      }

      return [];
    } catch (exception) {
      console.log(exception);
      return [];
    }
  };

  AssetExplorerTranslations.prototype._setTranslationsArrays = function () {
    let translations = [];

    try {
      translations = this.JsonObject?.fields?.children;
    } catch (exception) {
      console.log(exception);
    }

    this.AssetTypeTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.AssetType);
    this.AssetSubTypeTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.AssetSubType);
    this.CampaignTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.Campaign);
    this.OurCausesTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.OurCauses);
    this.KeywordTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.Keywords);
    this.RegionTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.Region);
    this.LanguageTranslations = this._setTranslationsArray(translations, AssetExplorerTranslations.FacetType.Language);

    translations?.map((t) => {
      this.FacetHeadings.push(t);
    });
  };

  const assetExplorerTranslations = new AssetExplorerTranslations(jsonData);
  return assetExplorerTranslations.Find(key, value);
}
